// extracted by mini-css-extract-plugin
export var contact__btn = "contact-module--contact__btn--32osa";
export var contact__link = "contact-module--contact__link--1MY4y";